// extracted by mini-css-extract-plugin
module.exports = {"Features":"Features_3NAe4","Features-List":"Features-List_1x5W6","Features-Feature":"Features-Feature_IB61K","Feature-Circle":"Feature-Circle_3IOdp"};